document.querySelector("body").addEventListener("mouseover", function (event) {
  if (event.target.dataset['name'] === "hover-item" ||  event.target.classList.contains('ignore-hover--js')) {
      return;
    }
  if (event.target.closest("header-menu")) {
    if (event.target.closest("li").classList.contains("active")) {
      return;
    }
    let thisLink = event.target.closest("li").querySelector("header-menu");
    tabHighlighterObj.set(thisLink);
    let activeLi = thisLink.closest("li");
    if (activeLi && activeLi?.classList.contains("active")) {
      thisLink.closest("li").classList.remove("active");
      document.querySelector(".tab-highlighter").style.display = "none";
    } else {
      document.querySelectorAll(".nav-li-item.active").forEach((e) => {
        e.querySelector("details").removeAttribute("open");
        e.classList.remove("active");
      });
      document.querySelector(".tab-highlighter").style.display = "flex";
      thisLink.closest("li").classList.add("active");
      thisLink.querySelector("details").setAttribute("open", true);
    }
  } else {
    document.querySelectorAll(".nav-li-item.active").forEach((e) => {
      e.classList.remove("active");
      e.querySelector("details").removeAttribute("open");
    });
    document.querySelector(".tab-highlighter").style.display = "none";
  }
});

window.addEventListener("click", function (event) {
  if (event.target.closest("header-menu")) {
    let thisLink = event.target.closest("li").querySelector("header-menu");
    tabHighlighterObj.set(thisLink);
    let activeLi = thisLink.closest("li");
    if (activeLi && activeLi?.classList.contains("active")) {
      thisLink.closest("li").classList.remove("active");
      document.querySelector(".tab-highlighter").style.display = "none";
    } else {
      document.querySelectorAll(".nav-li-item.active").forEach((e) => {
        e.classList.remove("active");
      });
      document.querySelector(".tab-highlighter").style.display = "flex";
      thisLink.closest("li").classList.add("active");
    }
  } else {
    document.querySelectorAll(".nav-li-item.active").forEach((e) => {
      e.classList.remove("active");
    });
    document.querySelector(".tab-highlighter").style.display = "none";
  }
});

var tabHighlighterObj = {
  set: function (link) {
    let li = link.closest("li");
    let tabHighlighter = document.querySelector(".tab-highlighter");
    tabHighlighter.style.left = li.getBoundingClientRect().left + "px";
    tabHighlighter.style.width = li.offsetWidth + "px";
  },
  refresh: function () {
    let activeLink = document.querySelector("header-menu details[open]");
    if (activeLink) {
      this.set(activeLink);
    } else {
      document.querySelector(".tab-highlighter").style.display = "none";
    }
  },
};

// Refresh on window resize
window.addEventListener("resize", function () {
  tabHighlighterObj.refresh();
});

// Initial refresh on document ready
document.addEventListener("DOMContentLoaded", function () {
  tabHighlighterObj.refresh();
});

//code for grand-child navigation (link) hover
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".has-grand-child").forEach((element) => {
    element.addEventListener("mouseover", (e) => {
      document.querySelectorAll(".has-grand-child").forEach((child) => {
        child.classList.remove("svg-link-active");
      });
      element.classList.add("svg-link-active");
      document.querySelectorAll(".grandchild-container").forEach((element) => {
        element.style.display = "none";
      });
      document.querySelector(
        `ul[data-handle="${element.dataset.handle}"]`
      ).style.display = "grid";
    });
  });
});
